import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import SystemAdminContent from './TheContent';
import SystemAdminFooter from './TheFooter';
import SystemAdminHeader from './TheHeader';
import SystemAdminSidebar from './TheSidebar';
import SystemAdminLicensees from './Licensees';
import { getURLParams } from '../../utils';
import { AUTH_PATH, MY_LEARNING_PATH } from '../../constants';
import { signOut } from '../../helpers/auth';
import { DataAddProduct as AdminDataAddProduct } from '../../helpers/system-admin';

import { setSubscriberUser } from '../../components/CMS/Subscriber/GlobalStates/CurrentUser/actions';

import SystemAdminPusher from './ThePusher';

const SystemAdminLayout = (props) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();

     const darkMode = useSelector((state) => state.general.darkMode);
     const user = useSelector((state) => state.subscriber.user);

     useEffect(() => {
          const params = getURLParams();
          if (params?.fromEmail === 'inviteManager') {
               if (params.userId !== user?.id) {
                    signOut(false, () => {
                         dispatch(setSubscriberUser(null));
                    });
                    navigate(AUTH_PATH.LOGIN);
               } else {
                    navigate(MY_LEARNING_PATH.DASHBOARD);
               }
          }
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <div className={classNames('admin c-app c-default-layout', { 'c-dark-theme': darkMode })}>
               <SystemAdminPusher />
               <AdminDataAddProduct />
               <SystemAdminLicensees />
               <SystemAdminSidebar />
               <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                    <SystemAdminHeader {...props} />
                    <div className="body flex-grow-1">
                         <SystemAdminContent />
                    </div>
                    <SystemAdminFooter />
               </div>
          </div>
     );
};

export default SystemAdminLayout;
